
namespace Gamification.Gamification {
    export class UtentiDelegatiConProprietaColumns {
        static columnsKey = 'Gamification.UtentiDelegatiConProprieta';
    }
}